module.exports = "<ng-directive-demo items=\"vm.items\"></ng-directive-demo>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/routes/directive-demo/directive-demo.html
 ** module id = 501
 ** module chunks = 0
 **/